import * as ExcelJS from 'exceljs';

function arreglarTiempoEstandar(time){
  const auxTiemposSeparados = time.split(':');
  const minutos = parseInt(auxTiemposSeparados[0]);
  const segundos = parseInt(auxTiemposSeparados[1]);
  const milisegundos = parseInt(auxTiemposSeparados[2]);
  if(minutos !== 0){
    return minutos + ':' + segundos + '.' + milisegundos;
  }else{
    return segundos + '.' + milisegundos;
  }
}

export async function exportTiempos(tiempos){
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(`Tiempos Resultados`);
  let cantNadadores = 1;
  tiempos.forEach((tiemp)=>{
    worksheet.addRow([`${tiemp.id + 1}`, `${tiemp.categoria}`]);
    worksheet.addRow([`${tiemp.prueba.prueba}`]);
    worksheet.addRow(['Psto', 'Ln', 'Sr', 'Deportista', 'Edad' , 'Insc.', 'Comp.', 'Equipo']);
    worksheet.mergeCells(`B${cantNadadores}:H${cantNadadores}`);
    worksheet.mergeCells(`A${cantNadadores + 1}:H${cantNadadores + 1}`);

    worksheet.getRow(cantNadadores).eachCell((cell) => {
      cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd8f1ff' }
      };
      cell.font = {
        size: '14',
      }
    });

    let contadorLugar = 1;
    tiemp.nadadores.forEach((nad)=>{
      worksheet.addRow([nad.posicion !== 9999 ? nad.posicion : 0, nad.carril, nad.serie, nad.nombre, nad.edad, arreglarTiempoEstandar(nad.record), arreglarTiempoEstandar(nad.tiempo), nad.nombreclub]);
      contadorLugar ++;
      cantNadadores ++;
    })
    worksheet.addRow([]);
    cantNadadores += 4;
  })

  //ancho columnas
  const columnA = worksheet.getColumn('A');
  columnA.width = 5;
  const columnB = worksheet.getColumn('B');
  columnB.width = 4;
  const columnC = worksheet.getColumn('C');
  columnC.width = 4;
  const columnD = worksheet.getColumn('D');
  columnD.width = 32;
  const columnE = worksheet.getColumn('E');
  columnE.width = 6;
  const columnF = worksheet.getColumn('F');
  columnF.width = 8;
  const columnG = worksheet.getColumn('G');
  columnG.width = 8;
  const columnH = worksheet.getColumn('H');
  columnH.width = 32;

  //centrar contenidos
  worksheet.eachRow((row)=>{
    row.eachCell((cell)=>{
      cell.alignment = {vertical: 'middle', horizontal: 'center'}
    })
  })

  // Establecer bordes para la tabla
  worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });
  });

  // Crea un Blob para descargar el archivo
  const blob = await workbook.xlsx.writeBuffer();
  const blobData = new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

  // Crea un enlace y simula un clic para descargar el archivo
  const url = URL.createObjectURL(blobData);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'Tiempos.xlsx';
  a.click();
}

export async function planillaToExcel(pruebas, nadadores, torneoEspecifico){
  const workbook = new ExcelJS.Workbook();
  pruebas.forEach((jornada, indexJor)=>{
    const worksheet = workbook.addWorksheet(`Jornada ${indexJor + 1}`);
    let cantNadadores = 1;
    let sumaNadadoresSerie = 0;
    jornada.forEach((prue)=>{
      sumaNadadoresSerie = 0;
      worksheet.addRow([`${prue.id}`, `${prue.categoria}`]);
      worksheet.addRow([`${prue.prueba.prueba}`]);
      worksheet.addRow(['Lugar', 'Carril', 'Deportista', 'Club', 'Tiempo']);
      if(nadadores[prue.id - 1].length !== 0){
        let contadorLugar = 1;
        nadadores[prue.id - 1].forEach((serie)=>{
          serie.nadadores.forEach((nadador)=>{
            worksheet.addRow([contadorLugar, torneoEspecifico.carril === '10' ? nadador.carril - 1 : nadador.carril, nadador.nombre[0], nadador.club[0], '']);
            contadorLugar ++;
          })
          sumaNadadoresSerie += serie.nadadores.length;
        })
      }
      worksheet.addRow([]);
      const cell = worksheet.getCell(`B${cantNadadores}`);
      if (!cell.isMerged) {
        //color encabezado
        worksheet.getRow(cantNadadores).eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'D9D9D9' } // gris
          };
          cell.font = {
            size: '14',
          }
        });

        worksheet.getRow(cantNadadores + 1).eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'D9D9D9' } // gris
          };
          cell.font = {
            size: '14',
          }
        });

        //combinar celdas
        worksheet.mergeCells(`B${cantNadadores}:E${cantNadadores}`);
        worksheet.mergeCells(`A${cantNadadores + 1}:E${cantNadadores + 1}`);
        cantNadadores += 4 + sumaNadadoresSerie;
      }
    })

    //centrar contenidos
    worksheet.eachRow((row)=>{
      row.eachCell((cell)=>{
        cell.alignment = {vertical: 'middle', horizontal: 'center'}
      })
    })

    // Establecer bordes para la tabla
    worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
    });

    // Establecer el formato de celda para que se interprete como tiempo
    const columnD = worksheet.getColumn('E');
    columnD.eachCell({ includeEmpty: true }, (cell, rowNumber) => {
      cell.numFmt = 'mm:ss.000';
    });
    const columnB = worksheet.getColumn('C');
    columnB.width = 32;
  })


  // Crea un Blob para descargar el archivo
  const blob = await workbook.xlsx.writeBuffer();
  const blobData = new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

  // Crea un enlace y simula un clic para descargar el archivo
  const url = URL.createObjectURL(blobData);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'Programación.xlsx';
  a.click();
}

export function tiemposToHy3(resultados, torneo){
  // Datos de ejemplo
  const meetInfo = { name: torneo.titulo, id: "0000000000" };
  const idClubs = {};
  const clubs = new Set();

  resultados.forEach((result)=>{
    result.nadadores.forEach((nad)=>{
      if(!idClubs[nad.nombreclub] && !nad.equipo){
        clubs.add({nombre: nad.nombreclub, codePais: nad.codePais ? nad.codePais : 'COL'});
        idClubs[nad.nombreclub] = nad.nombreclub;
      }
    })
  })

  let hy3Content = "";

  // Línea A: Información del meet
  hy3Content += `A ${meetInfo.name} ${meetInfo.id}\n`;
  
  // Línea B: Información del equipo
  Array.from(clubs).forEach((club, indexClub)=>{
    hy3Content += `B ${club.nombre}\t${club.codePais}\t00${indexClub + 1}\n`;
  })

  // Línea C: Información de los atletas
  resultados.forEach((result)=>{
    result.nadadores.forEach((nad)=>{
      if(!nad.equipo){
        hy3Content += `C ${nad.nombre}\t${nad.genero[0]}\t${nad.fechaNacimiento.replace(/-/g, '')}\tCOL\n`;
      }
    })
  })

  // Línea D: Información de eventos
  resultados.forEach((result)=>{
    result.nadadores.forEach((nad)=>{
      if(!nad.equipo){
        hy3Content += `D ${result.prueba.prueba}\t${nad.serie}\t${nad.carril}\t${nad.tiempo}\t${nad.codePais ? nad.codePais : 'COL'}\n`;
      }
    })
  })

  // Crear y descargar automáticamente el archivo
  const blob = new Blob([hy3Content], { type: "text/plain" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${torneo.titulo}.hy3`;
  link.click();
}